import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.small";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import Text from '../../../Atoms/Text/Text';
import { sizes } from '../../../../theme/shared/breakpoint';
import NavHelper from '../../../../utils/navHelper';
import InternalLinkHelper from '../../../../utils/internalLinkHelper';
import { Nav, NavMenu, NavItem, NavLink, SubNavMenu, SubNavItem, SubNavLink } from './Nav.style';

var FooterNav = function FooterNav(_ref) {
  var navItems = _ref.navItems;
  var menuGroups = navItems.menuGroups;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 1),
      isExpandable = _useState2[0];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      isSubMenuOpen = _useState4[0],
      setIsSubMenuOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSmallBreakpoint = _useState6[0],
      setIsSmallBreakpoint = _useState6[1]; // Detect window screen size when screen is resized


  var resize = function resize() {
    var screenSize = typeof window !== 'undefined' ? window.innerWidth : null;

    if (screenSize !== null) {
      setIsSmallBreakpoint(screenSize < parseFloat(sizes.small));
    }
  };

  if (typeof window !== 'undefined') {
    window.onresize = resize;
  }
  /**
   * Always stop the main 'parent' link from actually firing, but do the
   * collapsing for SM-MD breakpoints
   */


  var toggleSubMenu = function toggleSubMenu(item) {
    return function (event) {
      event.preventDefault(); // Only run on SM, as we're only using the hide-show logic on SM

      if (isSmallBreakpoint) {
        setIsSubMenuOpen(_defineProperty({}, item, !isSubMenuOpen[item]));
      }
    };
  };

  useEffect(function () {
    // Detect window screen size when page load
    var width = typeof window !== 'undefined' ? window.innerWidth : null;
    setIsSmallBreakpoint(width < parseFloat(sizes.small));
  }, []);
  return React.createElement(Nav, {
    "aria-labelledby": "main-menu",
    isExpandable: isExpandable,
    role: "navigation"
  }, React.createElement(Text, {
    id: "footer-menu",
    tag: "h2"
  }, "Footer navigation"), React.createElement(NavMenu, {
    role: "menubar"
  }, menuGroups.map(function (group, index) {
    return React.createElement(NavItem, {
      key: group.id,
      index: index,
      isSubMenuOpen: !!isSubMenuOpen[group.id]
    }, !isSmallBreakpoint ? React.createElement(Text, {
      color: "white",
      weight: "bold"
    }, group.title) : React.createElement(NavLink, {
      href: "#",
      inline: true,
      "aria-expanded": !!isSubMenuOpen[group.id],
      "aria-haspopup": "true",
      role: "button",
      onClick: toggleSubMenu(group.id)
    }, React.createElement(Text, {
      color: "white"
    }, group.title)), group.links && group.links.length > 0 && React.createElement(SubNavMenu, {
      role: "list",
      "aria-label": group.title,
      isSubMenuOpen: !!isSubMenuOpen[group.id],
      column: group.links.length % 2 === 0 && group.links.length > 2
    }, group.links.map(function (child) {
      /* Determine which field represents our url path */
      var thisUrl = NavHelper(child);
      thisUrl = InternalLinkHelper(thisUrl);
      return React.createElement(SubNavItem, {
        key: thisUrl,
        column: group.links.length % 2 === 0 && group.links.length > 2
      }, React.createElement(SubNavLink, {
        href: thisUrl,
        inline: true,
        role: "menuitem"
      }, React.createElement(Text, {
        color: "white"
      }, child.title)));
    })));
  })));
};

FooterNav.defaultProps = {
  navItems: {}
};
export default FooterNav;